export default function SlidellHelpfulResourcesSection() {
  const photoLocations = [
    { name: "CVS Pharmacy — Slidell", address: "142 Fremaux Ave, Slidell, LA 70460", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Slidell", address: "1630 Gause Blvd, Slidell, LA 70458", hours: "Call for hours" },
    { name: "CVS Pharmacy — Northshore", address: "3244 E Causeway Approach, Mandeville, LA 70448", hours: "Daily 7 AM – 11 PM" },
    { name: "The UPS Store — Slidell", address: "1200 Gause Blvd, Slidell, LA 70458", hours: "Call for hours" },
    { name: "Walgreens — Covington", address: "318 N Highway 190, Covington, LA 70433", hours: "Call for hours" },
    { name: "CVS Pharmacy — Lacombe", address: "59330 US-190, Lacombe, LA 70445", hours: "Daily 7 AM – 11 PM" },
  ];

  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Resources for Slidell Travelers
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Getting your passport ready involves more than just the application. Here are local Northshore resources to help you gather everything you need before your next international trip.
          </p>
        </div>

        <div className="space-y-6">
          {/* Passport Photos */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-camera-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Passport Photos</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Passport Photo Locations Near Slidell</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-4">
                Your passport application requires two identical 2&quot;&times;2&quot; passport photos taken within the last 6 months. Popular passport photo locations near Slidell and St. Tammany Parish include:
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                {photoLocations.map((loc, i) => (
                  <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-3.5">
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{loc.name}</p>
                    <p className="text-gray-500 text-xs leading-relaxed">{loc.address}</p>
                    <p className="text-gray-400 text-xs mt-1">{loc.hours}</p>
                  </div>
                ))}
              </div>
              <div className="bg-[#F7F8FA] border border-gray-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-lightbulb-line text-[#F6C344] mr-1.5"></i>
                  <strong>Tip:</strong> Wear a plain white or off-white top, no glasses, neutral expression. Photos must meet strict U.S. State Department specifications.
                </p>
              </div>
            </div>
          </div>

          {/* DMV */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-id-card-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Driver&apos;s License &amp; State ID</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">St. Tammany Parish DMV Services</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                A valid government-issued photo ID is required for your passport application. The Louisiana Office of Motor Vehicles handles driver&apos;s license and REAL ID services in St. Tammany Parish.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
                {[
                  {
                    name: "Louisiana OMV — Slidell Office",
                    address: "1900 Front St, Slidell, LA 70458",
                    hours: "Mon–Fri, 8:00 AM – 4:00 PM",
                    note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
                    featured: true,
                  },
                  {
                    name: "Louisiana OMV — Covington Office",
                    address: "2121 Holiday Blvd, Covington, LA 70433",
                    hours: "Mon–Fri, 8:00 AM – 4:00 PM",
                    note: "Covington area DMV services. Call ahead for current wait times.",
                    featured: false,
                  },
                ].map((loc, i) => (
                  <div key={i} className={`rounded-lg p-4 border ${loc.featured ? "bg-amber-50 border-[#F6C344]/40" : "bg-[#F7F8FA] border-gray-200"}`}>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                      </div>
                      <div>
                        <p className="font-bold text-[#1A365D] text-xs leading-snug">{loc.name}</p>
                        <p className="text-gray-500 text-xs mt-1">{loc.address}</p>
                        <p className="text-gray-400 text-xs mt-0.5">{loc.hours}</p>
                        <p className="text-[#1A365D] text-xs font-medium mt-1.5 leading-snug">{loc.note}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-calendar-check-line text-amber-500 mr-1.5"></i>
                  <strong>Appointment recommended</strong> — walk-in wait times can be long.
                </p>
              </div>
            </div>
          </div>

          {/* Vital Records */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-file-text-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Vital Records</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Louisiana Birth, Death, Marriage &amp; Divorce Records</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                If you need a certified copy of your birth certificate for your passport application — or need to update other vital records — the Louisiana Department of Health Vital Records Registry handles all statewide vital records requests. St. Tammany Parish-specific records can also be obtained through the St. Tammany Parish Clerk of Court.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
                {[
                  {
                    title: "Louisiana Vital Records Registry",
                    description: "Order certified copies of Louisiana birth and death certificates online, by mail, or in person at the state office in New Orleans.",
                    url: "https://ldh.la.gov/page/vital-records",
                    label: "LA Vital Records Registry",
                    featured: true,
                  },
                  {
                    title: "VitalChek \u2014 Louisiana Birth &amp; Death Certificates",
                    description: "Third-party expedited service for Louisiana birth and death certificates. Faster processing for an additional fee.",
                    url: "https://www.vitalchek.com/",
                    label: "Order Online via VitalChek",
                    featured: false,
                  },
                ].map((resource, i) => (
                  <div key={i} className={`rounded-lg p-4 border ${resource.featured ? "bg-amber-50 border-[#F6C344]/40" : "bg-[#F7F8FA] border-gray-200"}`}>
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{resource.title}</p>
                    <p className="text-gray-500 text-xs leading-relaxed mb-3">{resource.description}</p>
                    <a href={resource.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors">
                      <i className="ri-external-link-line text-sm"></i>{resource.label}
                    </a>
                  </div>
                ))}
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-information-line text-amber-500 mr-1.5"></i>
                  <strong>Marriage and divorce records</strong> are maintained by the St. Tammany Parish Clerk of Court, not the state vital records office. Contact the parish clerk directly for certified copies of marriage licenses and divorce decrees issued in St. Tammany Parish.
                </p>
              </div>
              <div className="bg-[#F7F8FA] border border-gray-200 rounded-md p-3 mt-4">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-passport-line text-[#F6C344] mr-1.5"></i>
                  <strong>Passport tip:</strong> Your birth certificate must be a certified copy with a raised seal, stamp, or registrar&apos;s signature. Photocopies and hospital-issued certificates are not accepted by the U.S. Department of State.
                </p>
              </div>
            </div>
          </div>

          {/* Airports */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-flight-takeoff-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Airports</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Airports Serving Slidell Travelers</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                Most Slidell travelers use New Orleans Louis Armstrong International Airport (MSY) for commercial flights. The airport is about 40 miles west of Slidell via I-10. Make sure your passport is in hand well before your departure date.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
                {[
                  {
                    code: "MSY",
                    name: "New Orleans Louis Armstrong International Airport",
                    distance: "About 40 miles west of Slidell via I-10",
                    address: "900 Airline Dr, Kenner, LA 70062",
                    note: "Primary commercial airport for Slidell and St. Tammany Parish. Nonstop service to major domestic and international hubs.",
                    flightUrl: "https://www.flyneworleans.com/",
                    flightLabel: "MSY Airport Website",
                    featured: true,
                  },
                  {
                    code: "GPT",
                    name: "Gulfport-Biloxi International Airport",
                    distance: "About 55 miles northeast of Slidell via I-10",
                    address: "14035 Airport Rd, Gulfport, MS 39503",
                    note: "Secondary option for Slidell travelers, especially for Gulf Coast and Southeast U.S. routes.",
                    flightUrl: "https://www.flygpt.com/",
                    flightLabel: "Gulfport Airport",
                    featured: false,
                  },
                ].map((airport, i) => (
                  <div key={i} className={`rounded-lg p-4 border ${airport.featured ? "bg-amber-50 border-[#F6C344]/40" : "bg-[#F7F8FA] border-gray-200"}`}>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-[#1A365D] font-black text-xl leading-none">{airport.code}</span>
                      {airport.featured && <span className="text-xs font-bold text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full">Primary</span>}
                    </div>
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{airport.name}</p>
                    <div className="flex items-center gap-1.5 text-xs text-[#F6C344] font-semibold mb-2">
                      <i className="ri-road-map-line"></i>
                      <span>{airport.distance}</span>
                    </div>
                    <p className="text-gray-500 text-xs leading-relaxed mb-1">{airport.address}</p>
                    <p className="text-gray-400 text-xs leading-relaxed mb-3">{airport.note}</p>
                    <a href={airport.flightUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors">
                      <i className="ri-external-link-line text-sm"></i>{airport.flightLabel}
                    </a>
                  </div>
                ))}
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-passport-line text-amber-500 mr-1.5"></i>
                  <strong>Passport required for all international flights.</strong> If your departure is within two weeks, <a href="https://fastpassportcenter.com/checkout/" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">expedited processing through Fast Passport Center</a> is your most reliable option.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}